import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import {
  Grid2 as Grid,
  Skeleton,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import { Charity, AddressUs } from "../../../shared/types";
import { getCharity } from "../../../shared/utilities/actions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export interface ItemProps {
  ein: string;
  handleSelect: () => void;
}

export const Item = ({ ein, handleSelect }: ItemProps): React.JSX.Element => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const tablet = useMediaQuery(theme.breakpoints.down("lg"));

  const [busy, setBusy] = useState<boolean>(true);
  const [charity, setCharity] = useState<Charity | null>();
  const [size, setSize] = useState<number>(mobile ? 12 : tablet ? 4 : 3);

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let charityResponse: Charity | null = await getCharity(ein);
      setCharity(charityResponse);
      setBusy(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (charity?.managed.displayBannerUrl.indexOf("default") == -1) {
      setSize(mobile ? 12 : tablet ? 6 : 6);
    } else {
      setSize(mobile ? 12 : tablet ? 4 : 3);
    }
  }, [charity]);

  if (!busy && charity) {
    let address: AddressUs = JSON.parse(charity.managed.displayAddress);
    return (
      <Grid
        size={size}
        onClick={() => {
          handleSelect();
        }}
      >
        <Box
          sx={{
            "& img": { boxShadow: 3 },
            "& h5": { color: "#272643" },
            "& p": { borderLeft: "3px solid #272643" },
            "&:hover": {
              "& img": { boxShadow: 8 },
              "& h5": { color: "rgb(44, 105, 141)" },
              "& p": { borderLeft: "3px solid rgb(44, 105, 141)" },
            },
            padding: "16px",
            cursor: "pointer",
            border: "1px solid #eeeeee",
            borderRadius: "12px",
            height: "100%",
          }}
        >
          <Grid size={{ xs: 12 }} container spacing={2}>
            {charity.managed.displayBannerUrl.indexOf("default") == -1 && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <img
                  src={charity.managed.displayBannerUrl}
                  style={{
                    borderRadius: "12px",
                    width: "100%",
                    maxHeight: "158px",
                    objectFit: "cover",
                  }}
                />
              </Grid>
            )}
            <Grid
              size={{
                xs: 12,
                sm:
                  charity?.managed.displayBannerUrl.indexOf("default") == -1
                    ? 6
                    : 12,
              }}
            >
              <Typography variant="h5">
                {charity.managed.displayName}
              </Typography>
              <Typography
                variant="body1"
                component="div"
              >{`EIN: ${charity.ein.slice(0, 2)}-${charity.ein.slice(2)} ${
                charity.chapter
              }`}</Typography>
              <Typography variant="body1" component="div">
                {address
                  ? `${address.city}, ${address.state}`
                  : "Location Unknown"}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        size={size}
        sx={{
          paddingBottom: "24px",
        }}
      >
        <Grid size={{ xs: 12 }}>
          <Skeleton />
        </Grid>
      </Grid>
    );
  }
};
